<div class="flex min-h-full flex-col sm:justify-center py-12 sm:px-6 lg:px-8">
  <div class="sm:mx-auto sm:w-full sm:max-w-md">
    <img src="../assets/logos/official/SHOUT_studio_logo_full_colour_black.svg" class="mx-auto h-12 w-auto dark:hidden" alt="SHOUT">
    <img src="../assets/logos/official/SHOUT_studio_logo_full_colour_white.svg" class="mx-auto h-12 w-auto hidden dark:block" alt="SHOUT">

    <h2 class="mt-10 text-center text-2xl font-semibold tracking-tight text-primary sm:text-4xl use-grotesque">
      @if (success()) {
      Password updated
      } @else {
      Reset your password
      }
    </h2>
  </div>

  <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
    <div class="primary-card-container outline -outline-offset-1 outline-white/10 sm:rounded-lg sm:px-12">
      <div class="space-y-6 px-2 py-8">
        @if (success()) {
        <div role="status"
          class="flex items-start gap-x-3 rounded-md bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-200 dark:border-emerald-800/50 px-3 py-3">
          <p class="text-sm text-emerald-800 dark:text-emerald-200 leading-5">
            Your SHOUT password has been updated. You can sign in with your new password.
          </p>
        </div>
        <button type="button" class="flex w-full items-center justify-center primary-go-button" (click)="goToLogin()">
          Back to sign in
        </button>
        } @else {
        <fieldset [disabled]="isSubmitting()" class="flex flex-col gap-6">
          <div>
            <label for="new-password" class="block text-sm/6 font-medium text-primary">New password</label>
            <div class="mt-2">
              <input
                [formField]="passwordForm.password"
                id="new-password"
                [type]="passwordVisible() ? 'text' : 'password'"
                autocomplete="new-password"
                class="input-primary text-primary disabled:opacity-50 disabled:cursor-not-allowed" />
            </div>
          </div>

          <div>
            <label for="confirm-password" class="block text-sm/6 font-medium text-primary">Confirm password</label>
            <div class="mt-2">
              <input
                [formField]="passwordForm.confirmPassword"
                id="confirm-password"
                [type]="passwordVisible() ? 'text' : 'password'"
                autocomplete="new-password"
                class="input-primary text-primary disabled:opacity-50 disabled:cursor-not-allowed" />
            </div>
          </div>

          <button
            type="button"
            class="self-start text-xs font-normal text-gray-500 hover:underline"
            (click)="passwordVisible.set(!passwordVisible())">
            @if (passwordVisible()) {
            Hide passwords
            } @else {
            Show passwords
            }
          </button>
        </fieldset>

        @if (error()) {
        <div role="alert"
          class="flex items-start gap-x-3 rounded-md bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-800/50 px-3 py-3">
          <p class="text-sm text-red-700 dark:text-red-300 leading-5">{{ error() }}</p>
        </div>
        }

        <button
          type="button"
          (click)="submitReset()"
          [disabled]="isSubmitting() || passwordForm().invalid() || !oobCode()"
          class="flex w-full items-center justify-center gap-x-2 primary-go-button disabled:opacity-60 disabled:cursor-not-allowed">
          @if (isSubmitting()) {
          Updating...
          } @else {
          Update password
          }
        </button>

        <p class="text-center text-sm text-secondary">
          <a routerLink="/login" class="font-semibold text-accent hover:text-accent/90">Back to sign in</a>
        </p>
        }
      </div>
    </div>
  </div>
</div>
